import { render, staticRenderFns } from "./OpenClickBounce.vue?vue&type=template&id=0b4374c6&"
import script from "./OpenClickBounce.vue?vue&type=script&lang=js&"
export * from "./OpenClickBounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports